import { isString } from "lodash-es";

const getFileName = (path: string | undefined | null): string => {
  return isString(path) ? path.substring(path.lastIndexOf("/") + 1) : "";
};

export { getFileName };
